import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { Box, Container, Stack } from '@mui/material';

import Layout from '@components/common/Layout';
import ContactUs from '@components/Home/NewHome/ContactUs';

const ContactUsPage = () => {
  return (
    <Layout showMinNav={false}>
      <Container sx={{ marginTop: '10vh', marginBottom: '5vh' }}>
        <Stack gap={{ xs: 6, md: 10 }}>
          {/* <PillWrapper
            alignItems="center"
            textAlign="center"
            px={{ xs: 2, md: 6 }}
            label="CONTACT US"
          >
            <TitleBodyPoints
              title={'Book discovery call'}
              highlightText={'discovery'}
              body={
                'Get quick solutions and quote for your space by talking to our experts.'
              }
            />
          </PillWrapper> */}
          {/* <div className="App">
            <InlineWidget url="https://calendly.com/naturethings-discovery-call/naturethings-discovery-call?background_color=f9f2ec&primary_color=4c2e4f" />
          </div> */}
          <Box>
            <ContactUs title={'Get a quote'} />
          </Box>
        </Stack>
      </Container>
    </Layout>
  );
};

export async function getStaticProps({ locale }) {
  //  TODO: Add translations in different file and import it here
  // Fix this translation issue in contact us component
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default ContactUsPage;
